import { render, staticRenderFns } from "./AlbumComp.vue?vue&type=template&id=5d93f2c4&scoped=true&"
import script from "./AlbumComp.vue?vue&type=script&lang=ts&"
export * from "./AlbumComp.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumComp.vue?vue&type=style&index=0&id=5d93f2c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93f2c4",
  null
  
)

export default component.exports